import * as React from 'react'
import { Button } from '@mui/material'
import Box from '@mui/material/Box'
import Stepper from '@mui/material/Stepper'
import Step from '@mui/material/Step'
import StepLabel from '@mui/material/StepLabel'
import { ShowSelection } from './reservation/ShowSelection'
import { SeatSelection } from './reservation/SeatSelection'
import { PersonalInfoForm } from './reservation/PersonalInfoForm'
import { StepsNavigation } from './reservation/StepsNavigation'
import { Booking } from './reservation/Booking'
import { Categories } from './reservation/Categories'
import { Complete } from './reservation/Complete'
import { SeatTimer } from './reservation/SeatTimer'
import { useNavigate } from 'react-router-dom'
import PropTypes from 'prop-types'

const steps = ['Choix du spectacle', 'Sélection des catégories', 'Sélection des places', 'Coordonnées', 'Paiement']

export function Reservation({ step = 0, setSelectedTab }) {
  const [activeStep, setActiveStep] = React.useState(step)
  const [completed, setCompleted] = React.useState(step === 5)
  const [previousStepCompleted, setPreviousStepCompleted] = React.useState(false)
  const navigate = useNavigate()

  const handleReset = () => {
    setCompleted(false)
    setPreviousStepCompleted(false)
    setSelectedTab('1')
    navigate('/')
  }
  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1)
    setPreviousStepCompleted(false)
  }
  const totalSteps = () => {
    return steps.length
  }

  const isLastStep = () => {
    return activeStep === totalSteps() - 1
  }
  const handleNext = () => {
    if (!isLastStep()) {
      setActiveStep(activeStep + 1)
    }
    setPreviousStepCompleted(false)
  }
  const handleComplete = () => {
    setCompleted(true)
    setPreviousStepCompleted(false)
  }

  return (
    <Box sx={{ width: '100%', alignItems: 'center' }}>
      <Box sx={{ width: '100%' }}>
        <Stepper activeStep={activeStep} alternativeLabel>
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel
                sx={{
                  // Target the inner span that holds the label text
                  '& .MuiStepLabel-label': {
                    display: { xs: 'none', sm: 'block' }, // hide on xs, show on sm+
                    margin: '0px'
                  }
                }}
              >
                {label}
              </StepLabel>
            </Step>
          ))}
        </Stepper>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', px: 2 }}>
        <SeatTimer activeStep={activeStep} setActiveStep={setActiveStep} />
      </Box>
      <Box
        sx={{
          width: { xs: '100%', sm: '80%' },
          margin: { xs: '2px auto 0', sm: '4px auto 0' }
        }}
      >
        {completed ? (
          <React.Fragment>
            <Box sx={{ display: 'flex', flexDirection: 'column', pt: 2 }}>
              <Complete />
              <Button variant='outlined' onClick={handleReset}>
                Terminer
              </Button>
            </Box>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
                maxHeight: { xs: '60vh', sm: '70vh' },
                overflow: 'auto',
                mb: 2
              }}
            >
              {activeStep === 0 && <ShowSelection setPreviousStepCompleted={setPreviousStepCompleted} handleNext={handleNext} />}
              {activeStep === 1 && <Categories setPreviousStepCompleted={setPreviousStepCompleted} handleNext={handleNext} />}
              {activeStep === 2 && <SeatSelection setPreviousStepCompleted={setPreviousStepCompleted} handleNext={handleNext} />}

              {activeStep === 3 && <PersonalInfoForm setPreviousStepCompleted={setPreviousStepCompleted} handleNext={handleNext} />}
              {activeStep === 4 && <Booking />}
            </Box>

            <StepsNavigation
              sx={{
                position: 'sticky',
                bottom: 0,
                borderTop: '1px solid',
                borderColor: 'divider',
                bgcolor: 'background.paper',
                pt: 2,
                pb: 1
              }}
              previousStepCompleted={previousStepCompleted}
              steps={steps}
              activeStep={activeStep}
              handleBack={handleBack}
              handleComplete={handleComplete}
              handleNext={handleNext}
              handleReset={handleReset}
            />
          </React.Fragment>
        )}
      </Box>
    </Box>
  )
}

Reservation.propTypes = {
  step: PropTypes.number,
  setSelectedTab: PropTypes.func.isRequired
}
